<template>
  <div class="login-wrapper pa-4">
    <v-card class="elevation-12 rounded-xl overflow-hidden mx-auto" max-width="450">
      <v-toolbar dark :color="store.NOTARIA.Theme.Footer.FooterCSS.BackgroundColor" flat>
        <v-toolbar-title class="font-weight-bold">Inicio de Sesión</v-toolbar-title>
      </v-toolbar>
      
      <v-alert type="error" v-if="errorLogin" class="ma-4">
        Inicio de sesión incorrecto
      </v-alert>

      <v-card-text class="pa-6">
        <v-form @submit.prevent="login">
          <v-text-field 
            v-model="username" 
            prepend-inner-icon="mdi-account" 
            name="usuario" 
            label="Usuario"
            outlined
            rounded
            hide-details="auto"
            class="mb-4"
            type="text"
          ></v-text-field>
          
          <v-text-field 
            v-model="password" 
            id="password" 
            prepend-inner-icon="mdi-lock" 
            name="password" 
            label="Contraseña"
            outlined
            rounded
            hide-details="auto"
            type="password"
            @keyup.enter="login"
          ></v-text-field>
        </v-form>
      </v-card-text>
      
      <v-divider></v-divider>
      
      <v-card-actions class="pa-4 bg-light">
        <v-spacer></v-spacer>
        <v-btn 
          color="primary" 
          rounded 
          depressed 
          large 
          class="px-8 font-weight-bold" 
          @click="login"
          :loading="loading"
        >
          Entrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { useStore } from '../store/index'
const store = useStore()
const username = ref("")
const password = ref("")
const loading = ref(false)
const errorLogin = ref(false)

async function login() {
  if (!username.value || !password.value) return;
  
  loading.value = true;
  errorLogin.value = false;
  try {
    var result = await store.doLogin({ username: username.value, password: password.value })
    if (result) {
      await navigateTo("/")
    } else {
      errorLogin.value = true;
    }
  } catch (e) {
    errorLogin.value = true;
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.login-wrapper {
  width: 100%;
  display: block;
}
</style>